
      function getAbsoluteUrl(relativeUrl) {
        const publicPath = __webpack_public_path__;

        let url = '';

        if (!publicPath || publicPath.indexOf('://') < 0) {
          url += window.location.protocol + '//' + window.location.host;
        }

        if (publicPath) {
          url += publicPath;
        } else {
          url += '/';
        }

        return url + relativeUrl;
      }
export const packageInfo = {
  name: '@polkadot/types-known',
  path: ({ url: getAbsoluteUrl('node_modules/.pnpm/@polkadot+types-known@10.6.1/node_modules/@polkadot/types-known/packageInfo.js') }) && ({ url: getAbsoluteUrl('node_modules/.pnpm/@polkadot+types-known@10.6.1/node_modules/@polkadot/types-known/packageInfo.js') }).url ? new URL(({ url: getAbsoluteUrl('node_modules/.pnpm/@polkadot+types-known@10.6.1/node_modules/@polkadot/types-known/packageInfo.js') }).url).pathname.substring(0, new URL(({ url: getAbsoluteUrl('node_modules/.pnpm/@polkadot+types-known@10.6.1/node_modules/@polkadot/types-known/packageInfo.js') }).url).pathname.lastIndexOf('/') + 1) : 'auto',
  type: 'esm',
  version: '10.6.1'
};